(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n10-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.n10PopupReady) return;
  window.n10PopupReady = true;

  var KEY = 'n10_popup';

  function ler() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function gravar(obj) {
    try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {}
  }

  function init() {
    var pop = document.querySelector('[data-n10-popup]');
    if (!pop || pop.dataset.pronto) return;
    pop.dataset.pronto = '1';

    var versao = pop.dataset.version || '1';
    var estado = ler();
    var agora = Date.now();
    var pill = document.querySelector('[data-popup-pill]');
    var PILL_KEY = 'n10_popup_pill_off';

    function pillEscondida() {
      try { return sessionStorage.getItem(PILL_KEY) === '1'; } catch (e) { return false; }
    }
    function mostrarPill() {
      if (!pill || pillEscondida()) return;
      pill.hidden = false;
    }
    function esconderPill(lembrar) {
      if (!pill) return;
      pill.hidden = true;
      if (lembrar) { try { sessionStorage.setItem(PILL_KEY, '1'); } catch (e) {} }
    }

    function abrir() {
      pop.hidden = false;
      esconderPill(false);
      document.documentElement.classList.add('n10-popup-aberto');
      var campo = pop.querySelector('input[type="text"], input[type="email"]');
      if (campo) setTimeout(function () { campo.focus(); }, 50);
    }
    function fechar() {
      pop.hidden = true;
      document.documentElement.classList.remove('n10-popup-aberto');
      if (!pop.dataset.openNow) {
        gravar({ v: versao, ate: agora + 7 * 24 * 60 * 60 * 1000 });
      }
      var feito = ler();
      if (!(feito.feito && feito.v === versao)) mostrarPill();
    }

    if (pill) {
      pill.querySelector('[data-popup-pill-open]').addEventListener('click', abrir);
      pill.querySelector('[data-popup-pill-close]').addEventListener('click', function () { esconderPill(true); });
    }

    pop.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', fechar);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) fechar();
    });

    var form = pop.closest('form');
    var tel = pop.querySelector('[data-popup-phone]');
    var tags = pop.querySelector('[data-popup-tags]');
    if (form && tel && tags) {
      form.addEventListener('submit', function () {
        var digitos = (tel.value || '').replace(/\D/g, '');
        if (digitos) tags.value = 'popup-primeira-compra, whatsapp:' + digitos;
        gravar({ v: versao, feito: true });
      });
    }

    var copiar = pop.querySelector('[data-popup-copy]');
    if (copiar) {
      copiar.addEventListener('click', function () {
        var code = pop.querySelector('[data-popup-code]').textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () { copiar.textContent = 'Copiado!'; });
        }
      });
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#cupom"]');
      if (a) { e.preventDefault(); abrir(); }
    });

    if (pop.dataset.openNow) {
      abrir();
      return;
    }
    if (window.location.hash === '#cupom') {
      abrir();
      return;
    }
    if (estado.feito && estado.v === versao) return;
    if (estado.ate && estado.ate > agora && estado.v === versao) {
      mostrarPill();
      return;
    }

    var delay = parseInt(pop.dataset.delay, 10) || 6000;
    setTimeout(abrir, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["n10-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.n10QuizReady) return;
  window.n10QuizReady = true;

  function montar(box) {
    var dados;
    try {
      dados = JSON.parse(box.querySelector('[data-n10-quiz-data]').textContent);
    } catch (e) {
      return;
    }
    var intro = box.querySelector('[data-quiz-intro]');
    var steps = box.querySelector('[data-quiz-steps]');
    var result = box.querySelector('[data-quiz-result]');
    var bar = box.querySelector('[data-quiz-bar]');
    var count = box.querySelector('[data-quiz-count]');
    var question = box.querySelector('[data-quiz-question]');
    var options = box.querySelector('[data-quiz-options]');
    var back = box.querySelector('[data-quiz-back]');
    var respostas = [];
    var atual = 0;

    function mostrar(el, on) {
      el.hidden = !on;
    }

    function render() {
      var p = dados.perguntas[atual];
      var total = dados.perguntas.length;
      bar.style.width = Math.round(((atual) / total) * 100) + '%';
      count.textContent = 'Pergunta ' + (atual + 1) + ' de ' + total;
      question.textContent = p.q;
      options.innerHTML = '';
      p.opts.forEach(function (o, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'n10-quiz__opt';
        b.textContent = o.t;
        b.addEventListener('click', function () {
          respostas[atual] = i;
          if (atual < total - 1) {
            atual += 1;
            render();
          } else {
            finalizar();
          }
        });
        options.appendChild(b);
      });
      back.hidden = atual === 0;
      question.focus && question.setAttribute('tabindex', '-1');
      question.focus();
    }

    function finalizar() {
      var placar = {};
      dados.perguntas.forEach(function (p, i) {
        var o = p.opts[respostas[i]];
        if (!o) return;
        Object.keys(o.p).forEach(function (k) {
          placar[k] = (placar[k] || 0) + o.p[k];
        });
      });
      var ordem = Object.keys(dados.linhas);
      var melhor = ordem[0];
      ordem.forEach(function (k) {
        if ((placar[k] || 0) > (placar[melhor] || 0)) melhor = k;
      });
      var linha = dados.linhas[melhor];
      box.querySelector('[data-quiz-linha]').textContent = linha.nome;
      box.querySelector('[data-quiz-why]').textContent = linha.porque;
      var art = box.querySelector('[data-quiz-art]');
      art.src = linha.arte || '';
      art.alt = linha.nome;
      var cta = box.querySelector('[data-quiz-cta]');
      var embreve = box.querySelector('[data-quiz-embreve]');
      if (linha.link) {
        cta.href = linha.link;
        cta.textContent = linha.cta;
        cta.hidden = false;
        embreve.hidden = true;
      } else {
        cta.hidden = true;
        embreve.hidden = false;
      }
      mostrar(steps, false);
      mostrar(result, true);
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    box.querySelector('[data-quiz-start]').addEventListener('click', function () {
      atual = 0;
      respostas = [];
      mostrar(intro, false);
      mostrar(result, false);
      mostrar(steps, true);
      render();
    });
    back.addEventListener('click', function () {
      if (atual > 0) {
        atual -= 1;
        render();
      }
    });
    box.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      atual = 0;
      respostas = [];
      mostrar(result, false);
      mostrar(steps, true);
      render();
    });
  }

  function init() {
    document.querySelectorAll('[data-n10-quiz]').forEach(function (box) {
      if (box.dataset.pronto) return;
      box.dataset.pronto = '1';
      montar(box);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
